<template>
  <container-component>
    <div class="mt-2 container-principal-historico"
         :class="{'container-principal-historico-dente-selecionado' : denteSelecionado}">
      <div v-if="itens.length === 0" class="container-historico-limpo">
        <span>Não há registros no histórico!</span>
      </div>
      <v-expansion-panels v-else flat style="overflow-y: auto">
        <v-expansion-panel v-for="item in itens" :key="item.id">
          <v-expansion-panel-header class="painel-historico-item-header">
            <span>{{ item.denteNome }} - {{ item.dataInicio | filterDataHora }}</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="painel-historico-item-content">
            <div class="container-historico-item-header-detalhes">
              <div class="text-info-item-historico mb-5">
                <label>Código</label><br/>
                <span>{{ item.codigoAtendimento }}</span>
              </div>
              <div class="text-info-item-historico" style="margin-left: 43px">
                <label>Dentista</label><br/>
                <span>{{ item.dentistaNome | filterTextoGrande(30) }}</span>
              </div>
              <div v-if="permiteEditarAtendimento">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn icon @click="editarProcedimento(item)">
                        <v-icon color="primary">edit</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  Editar procedimento
                </v-tooltip>
              </div>
              <div v-if="!permiteEditarAtendimento">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn icon disabled>
                        <v-icon color="primary">edit</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  Não é possível editar este procedimento!
                </v-tooltip>
              </div>
            </div>
            <div class="subcontainer-detalhes-item">
              <div>
                <FacesDentesHistoricoItem :faces="item"/>
                <div class="detalhes-procedimentos-item mt-2">
                  <v-icon small class="primary--text" v-if="item.ehExtraido">fas fa-check</v-icon>
                  <v-icon small class="error--text" v-if="!item.ehExtraido">fa fa-times</v-icon>
                  <label class="ml-1">Extraído</label>
                </div>
                <div class="detalhes-procedimentos-item">
                  <v-icon small class="primary--text" v-if="item.ehCanal">fas fa-check</v-icon>
                  <v-icon small class="error--text" v-if="!item.ehCanal">fa fa-times</v-icon>
                  <label class="ml-1">Canal</label>
                </div>
                <div class="detalhes-procedimentos-item">
                  <v-icon small class="primary--text" v-if="item.ehRestaurado">fas fa-check</v-icon>
                  <v-icon small class="error--text" v-if="!item.ehRestaurado">fa fa-times</v-icon>
                  <label class="ml-1">Restaurado</label>
                </div>
              </div>
              <div class="text-info-item-historico ml-5">
                <label>Descrição</label><br/>
                <span>{{ item.descricao | textoSemValor }}</span>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="pagination mt-2" slot="footer">
        <v-pagination
            v-if="paginas > 1"
            v-model="paginacaoInterna.page"
            total-visible="7"
            :length="paginas"
        />
        <v-spacer v-if="paginas <= 1"/>
        <div class="select-pagination" v-if="false">
          <span>Linhas por página:</span>
          <v-select :items="linhasPorPagina" @change="resetaPage" v-model="paginacaoInterna.size"/>
        </div>
      </div>
    </div>
  </container-component>
</template>

<script>
import mutationTypes from '@/core/constants/mutationTypes'
import ContainerComponent from '@/views/components/Container.vue'
import FacesDentesHistoricoItem from '@/views/pages/cadastros/paciente/comum/odontograma/FacesDenteHistoricoItem.vue'

export default {
    name: 'OdontogramaProcedimentoTabela',
    components: {FacesDentesHistoricoItem, ContainerComponent},
    props: ['itens', 'paginacao', 'paginas', 'denteSelecionado', 'permiteEditarAtendimento'],
    data() {
        return {
            paginacaoInterna: this.paginacao,
            linhasPorPagina: [10, 25, 50, 100],
        }
    },
    methods: {
        resetaPage() {
            this.$store.commit(mutationTypes.ATENDIMENTO.PROCEDIMENTO.RESETA_PAGE)
        },
        editarProcedimento(procedimento) {
            this.$emit('editarProcedimento', procedimento)
        }
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true,
        },
    },
}
</script>

<style scoped lang="stylus">

.container-principal-historico
  height 425px
  display flex
  flex-direction column
  justify-content space-between

.container-historico-limpo
  display flex
  justify-content center
  align-items center
  height 100px
  background-color #e0e0e0

.container-principal-historico-dente-selecionado
  height 315px

.painel-historico-item-header
  border-bottom solid 1px #e7e7e7 !important
  background-color #F6F6F6
  border-radius 5px !important
  min-height 20px !important
  padding-bottom 10px
  padding-top 10px

.v-expansion-panel-header--active
  border-bottom-left-radius 0 !important
  border-bottom-right-radius 0 !important

.painel-historico-item-content
  border 1px solid #e7e7e7
  border-top-style none
  border-radius 5px
  border-top-left-radius 0
  border-top-right-radius 0

  >>> .v-expansion-panel-content__wrap
    padding 5px

.container-historico-item-header-detalhes
  margin-top 10px
  display flex

.subcontainer-detalhes-item
  display flex

.detalhes-procedimentos-item
  display flex

.text-info-item-historico
  label
    font-weight bold
    color var(--theme-primary)

</style>
